import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu } from '../../models/menu';
import { MenuService } from '../../../mds/settings/services/menu.service'
import { LegendLabelsContentArgs } from "@progress/kendo-angular-charts";
import { IntlService } from "@progress/kendo-angular-intl";
import { DashboardSummary } from '../../models/dashboardsummary';
import { DashboardService } from '../../services/dashboard.service';
import { ConfigService } from '@gbs-platform-client/fwk-core';
@Component({
  selector: 'app-Mainmenu',
  templateUrl: './Mainmenu.component.html',
  styleUrls: ['./Mainmenu.component.css']
})
export class MainMenuComponent implements OnInit {
  activeMenuId: string = "";
  activeMenuName: string = "";
  activeModuleName: string = "";
  activeMenuIcon: string = "";
  allMenuList: Array<Menu> = [];
  groupMenuList: Array<Menu> = [];
  menuList: Array<Menu> = [];
  showINMDashboard = false;
  showMMDashboard = false;
  showCRDashboard = false;
  // dashSummary: Array<DashboardSummary> = [];
  currentDash: DashboardSummary = new DashboardSummary();
  pageIndex: number = 1;
  pageSize: number = 10;
  fromRow: number = 0;
  toRow: number = 0;
  totalRows = 0;
  showDetail = false;
  dash: DashboardSummary = new DashboardSummary();
  request: any;
  approve: any;
  level1: any;
  level2: any;
  level3: any;
  total: any;
  selected: any;
  training: any;
  showselect: boolean = false;
  selectedColumns: any;
  requestColumns: any;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  formCaption: string = '';
  dashSummary: any;
  defaultRowsCount: number;
  currentReportId: number = 0;
  public pieData: any[] = [
    { category: "1st Level Shortlisted", value: 300 },
    { category: "2nd Level Shortlisted", value: 450 },
    { category: "3rd Level Shortlisted", value: 120 },
    { category: "Seleted Candidates", value: 100 },
    { category: "Candidates For Training", value: 95 },
  ];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private intl: IntlService,
    private menuService: MenuService,
    private _dashboardService: DashboardService,
    private configService: ConfigService,) {
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.labelContent = this.labelContent.bind(this);
    //this.getMDSSummaryCounts('');
    // this.getAllSelectedCandidates(''); 
    this.request = [];
    this.approve = [];
    this.level1 = [];
    this.level2 = [];
    this.level3 = [];
    this.total = [];
    this.selected = [];
    this.training = [];
    {
      this.requestColumns = [
        { field: "Request_No", title: 'Request No.', filter: true, sortable: true, width: 100 },
        { field: "Requested_Date", title: 'Requested Date', filter: true, sortable: true, width: 100 },
        { field: "LocationName", title: 'Location ', filter: true, sortable: true, width: 100 },
        { field: "Post_Name", title: 'Post', filter: true, sortable: true, width: 100 },
        { field: "No_Of_Vaccancies", title: 'No Of Vaccancies', filter: true, sortable: true, width: 100 },

      ];
      this.request = [];
      this.selectedColumns = [
        { field: "CandidateName", title: 'Candidate Name', filter: true, sortable: true, width: 100 },
        { field: "RegistrationNo", title: 'Registration No', filter: true, sortable: true, width: 100 },
        { field: "EmailId", title: 'Email Id', filter: true, sortable: true, width: 100 },
        { field: "ContactNo", title: 'Contact', filter: true, sortable: true, width: 100 },
        { field: "PostName", title: 'Post', filter: true, sortable: true, width: 100 },

      ];
      this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
      this.pageSizes = this.configService.getConfigValue('pageSizes');
      this.selected = [];
    }
  }

  public labelContent(args: LegendLabelsContentArgs): string {
    return `${args.dataItem.category} - ${args.dataItem.value}`;
  }

  getMDSSummaryCounts(filter: string) {
    this._dashboardService.getSummaryCounts('', Number(this.defaultPageSize), 1).subscribe((dashSummary: Array<DashboardSummary>) => {
      this.dashSummary = dashSummary;
    });
  }

  getAllVacancy(filter: string): void {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
  }

  initShowingData(dash: DashboardSummary) {
    this.pageIndex = 1;
    this.currentReportId = dash.ReportId;
    switch (this.currentReportId) {
      case 1:
        this.formCaption = "Requested Job Vacancies";

        break;
      case 2:
        this.formCaption = "Approved Job Vacancies";

        break;
      case 3:
        this.formCaption = "Total Candidates";

        break;
      case 4:
        this.formCaption = "Level 1- Shortlisted";

        break;
      case 5:
        this.formCaption = "Level 2- Shortlisted";

        break;
      case 6:
        this.formCaption = "Level 3- Shortlisted";

        break;
      case 7:
        this.formCaption = "Selected Candidates";

        break;
      case 8:
        this.formCaption = "Candidates for Training";

        break;
    }
    // this.getAllRequestedVacancies('');
    // this.getAllApprovedVacancies('');
    // this.getAllLevel1Shortlisted('');
    // this.getAllLevel2Shortlisted('');
    // this.getAllLevel3Shortlisted('');
    // this.getAllTotalCandidates('');
    // this.getAllSelectedCandidates('');
    // this.getAllCandidatesTraining('');
  }
  closeView(): void {
    this.showDetail = false;
  }
  ngOnInit(): void {
    this.menuService.viewMenuByModule(String(this.route.snapshot.paramMap.get('id'))).subscribe((resp: Array<any>) => {
      if (resp) {
        this.allMenuList = resp;
        this.groupMenuList = resp.filter(x => x.Menu_Parent_Id === null);
        const dashMenu = resp.find(x => x.Menu_Name === 'Dashboard');
        if (dashMenu && dashMenu.Menu_Id != "") {
          this.activeMenuId = dashMenu.Menu_Id;
          this.activeMenuName = dashMenu.Menu_Name; 
          this.activeModuleName = dashMenu.Module_Name;
          this.activeMenuIcon = dashMenu.Menu_Icon;
          
          if (this.route.snapshot.paramMap.get('mid') && String(this.route.snapshot.paramMap.get('mid')) != "") {
            let menu = this.groupMenuList.find(x => x.Menu_Id.toUpperCase() == String(this.route.snapshot.paramMap.get('mid')).toUpperCase());
             
            if (menu) {              
              this.setGroupMenu(menu);
            }
          } else {
            if (this.route.snapshot.paramMap.get('id') === "C597B738-1800-4DD5-8534-6AE6A33BCC04") {
              this.showINMDashboard = true;
            }
            if (this.route.snapshot.paramMap.get('id') === "CC95D93E-3CEC-4846-B90E-50D6B5E045BB") {
              this.showMMDashboard = true;
            }
            if (this.route.snapshot.paramMap.get('id') === "A854DE23-210B-46FB-96C8-D9D5DD675511") {
              this.showCRDashboard = true;
            }
          }
        }
        //this.getMDSSummaryCounts(''); 
      }
    });
  }

  navigateUrl(menu: Menu): void {
    if (menu.Menu_URL && menu.Menu_URL !== '') {
      this.router.navigate([menu.Menu_URL]);
    }
  }

  setGroupMenu(menu: Menu): void { 
    this.activeMenuId = menu.Menu_Id;
    this.activeModuleName = menu.Module_Name;
    this.activeMenuName = menu.Menu_Name;
    this.activeMenuIcon = menu.Menu_Icon;
    this.showINMDashboard = (menu.Menu_Name === 'Dashboard' && menu.Module_Id.toUpperCase() === "c597b738-1800-4dd5-8534-6ae6a33bcc04".toUpperCase())
    this.showMMDashboard = (menu.Menu_Name === 'Dashboard' && menu.Module_Id.toUpperCase() === "cc95d93e-3cec-4846-b90e-50d6b5e045bb".toUpperCase())
    this.showCRDashboard = (menu.Menu_Name === 'Dashboard' && menu.Module_Id.toUpperCase() === "a854de23-210b-46fb-96c8-d9d5dd675511".toUpperCase())
    
    if (!this.showINMDashboard && !this.showMMDashboard && !this.showCRDashboard) {      
      this.menuList = this.allMenuList.filter(x => x.Menu_Parent_Id === menu.Menu_Id);      
    }
  }

  getMenu(menuLevel: number): Array<Menu> {
    switch (menuLevel) {
      case 0:
        return this.menuList.filter(x => x.Menu_Parent_Id === "");
      case 1:
        return this.menuList.filter(x => x.Menu_Parent_Id === this.activeMenuId);
      default:
        return [];
        break;
    }
  }
}

function ngAfterViewInit() {
  throw new Error('Function not implemented.');
}

